import { render, staticRenderFns } from "./UseGasTop5.vue?vue&type=template&id=4b11a5ed&scoped=true&"
import script from "./UseGasTop5.vue?vue&type=script&lang=js&"
export * from "./UseGasTop5.vue?vue&type=script&lang=js&"
import style0 from "./UseGasTop5.vue?vue&type=style&index=0&id=4b11a5ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b11a5ed",
  null
  
)

export default component.exports